import { render, staticRenderFns } from "./coordinator-config.vue?vue&type=template&id=83652028"
import script from "./coordinator-config.ts?vue&type=script&lang=js&external"
export * from "./coordinator-config.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports